export default "__VITE_ASSET__CVdNh1xZ__"